import { render, staticRenderFns } from "./CachePoliciesInfo.vue?vue&type=template&id=24b82f7e&scoped=true&"
import script from "./CachePoliciesInfo.vue?vue&type=script&lang=js&"
export * from "./CachePoliciesInfo.vue?vue&type=script&lang=js&"
import style0 from "./CachePoliciesInfo.vue?vue&type=style&index=0&id=24b82f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b82f7e",
  null
  
)

export default component.exports